export enum FormFieldSubType {
	TEXT = "text",
	CHECKBOX = "checkbox",
	RADIOBUTTON = "radiobutton",
	PUSHBUTTON = "pushbutton",
	COMBOBOX = "combobox",
	LISTBOX = "listbox",
	SIGNATURE = "signature",
}